import { defineMessages } from "react-intl";

import { node as addictionAssessment } from "src/modules/ltx/forms/phase-i/consultations/addictionAssessment";
import { node as boneScan } from "src/modules/ltx/forms/phase-i/consultations/boneScan";
import { node as dentalScreening } from "src/modules/ltx/forms/phase-i/consultations/dentalScreening";
import { node as earNoseThroat } from "src/modules/ltx/forms/phase-i/consultations/earNoseThroat";
import { node as ercp } from "src/modules/ltx/forms/phase-i/consultations/ercp";
import { node as gynecology } from "src/modules/ltx/forms/phase-i/consultations/gynecology";
import { node as liverBiopsy } from "src/modules/ltx/forms/phase-i/consultations/liverBiopsy";
import { node as liverElastography } from "src/modules/ltx/forms/phase-i/consultations/liverElastography";
import { node as mrcp } from "src/modules/ltx/forms/phase-i/consultations/mrcp";
import { node as neurology } from "src/modules/ltx/forms/phase-i/consultations/neurology";
import { node as oncology } from "src/modules/ltx/forms/phase-i/consultations/oncology";
import { node as ophthalmologicExamination } from "src/modules/ltx/forms/phase-i/consultations/ophthalmologicExamination";
import { node as otherConsultations } from "src/modules/ltx/forms/phase-i/consultations/otherConsultations";
import { node as psychiatricAssessment } from "src/modules/ltx/forms/phase-i/consultations/psychiatricAssessment";
import { node as psychologicalAssessment } from "src/modules/ltx/forms/phase-i/consultations/psychologicalAssessment";
import { node as pulmonaryFunctionTest } from "src/modules/ltx/forms/phase-i/consultations/pulmonaryFunctionTest";
import { node as urology } from "src/modules/ltx/forms/phase-i/consultations/urology";
import { node as colonoscopia } from "src/modules/ltx/forms/phase-i/consultations/colonoscopia";
import { ParentNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	title: {
		id: "form.consultations",
		defaultMessage: "Konzíliumok"
	}
});

export const node: ParentNode = {
	id: "consultations",
	value: { type: "wizard", title: messages.title },
	children: [
		dentalScreening,
		earNoseThroat,
		urology,
		gynecology,
		ophthalmologicExamination,
		neurology,
		pulmonaryFunctionTest,
		addictionAssessment,
		psychiatricAssessment,
		psychologicalAssessment,
		ercp,
		mrcp,
		liverBiopsy,
		boneScan,
		oncology,
		otherConsultations,
		liverElastography,
		colonoscopia
	]
};
